import React, { useState, useEffect } from 'react';
import { 
    Table, TableBody, TableCell, TableContainer, TableRow, Paper, 
    TableHead, Button, TablePagination, TextField, Dialog, 
    DialogActions, DialogContent, DialogContentText, DialogTitle 
} from '@mui/material';
import AddCategoriaPregunta from './AddCategoriaPregunta';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';

function GestionCategoriaPregunta() {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [categoriasPregunta, setCategoriasPregunta] = useState([]);
    const [editCategoriaPregunta, setEditCategoriaPregunta] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [categoriaPreguntaToDelete, setCategoriaPreguntaToDelete] = useState(null);
    const { user } = useUser();
    const { tienePermiso } = useAccesos();

    const fetchCategoriasPreguntas = async () => {
            try {
                const response = await fetch(`${server}/CrmCategoriaPreguntums`);
                const data = await response.json();
                setCategoriasPregunta(data.$values);
                console.log("Respuesta de la API:", data);
            } catch (error) {
                console.error('Error al cargar las Categorias de Preguntas:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al cargar las Categorias de Preguntas: ' + error,
                });
            }
        };


        
            useEffect(() => {
                fetchCategoriasPreguntas();
            }, []);
        
            const handleNewCategoriaPregunta= () => {
                fetchCategoriasPreguntas();
                setEditCategoriaPregunta(null);
            };
        
            const handleChangePage = (event, newPage) => {
                setPage(newPage);
            };
        
            const handleChangeRowsPerPage = (event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            };
        
            const handleSearchChange = (event) => {
                setSearchQuery(event.target.value);
            };
        
            const handleOpenDialog = (categoriaPregunta) => {
                setCategoriaPreguntaToDelete(categoriaPregunta);
                setOpenDialog(true);
            };
        
            const handleCloseDialog = () => {
                setOpenDialog(false);
                setCategoriaPreguntaToDelete(null);
            };
        
            const handleDeleteCategoriaPregunta = async () => {
                if (categoriaPreguntaToDelete) {
                    try {
                        const username = ''+user.codigoUsuario+'/';
        
                        const response = await fetch(`${server}/CrmCategoriaPreguntums/${categoriaPreguntaToDelete.id}/${username}`, {
                            method: 'DELETE'
                        });

                        if (response.ok) {
                            handleCloseDialog();
                            fetchCategoriasPreguntas();
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Categoria de pregunta eliminada con éxito',
                            });
                        } else {
                            handleCloseDialog();
        
                            const errorData = await response.json();
                            const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                            Swal.fire({
                                icon: 'error',
                                title: `Error ${response.status}`,
                                text: errorMessage,
                            });
                        }
                    } catch (error) {
                        console.error('Error al eliminar la categoria de pregunta:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al eliminar la categoria de pregunta: ' + error,
                        });            }
                }
            };
        
            const filteredCategoriaPregunta = categoriasPregunta.filter(categoriaPregunta => categoriaPregunta.categoria?.toLowerCase().includes(searchQuery.toLowerCase()));
    
        const handleCancelarEdicion = () => {
            setEditCategoriaPregunta(null);
        }


return (
<>
    <div className="x_title">
        </div>

        <div className="x_content">
            <br />

            <AddCategoriaPregunta handleNewCategoriaPregunta={handleNewCategoriaPregunta} editCategoriaPregunta={editCategoriaPregunta} cancelarEdicion={handleCancelarEdicion}/>

            <div className="ln_solid" />

            <h2>Categorias de Preguntas existentes</h2> 

            <div className="row">
                <div className="col-md-6 col-sm-4 offset-md-3">
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Buscar Categoria"
                        placeholder="Buscar..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        style={{ marginBottom: '20px' }}
                    />

                    <div className="table-responsive">
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Descripción</TableCell>
                                        <TableCell align="right">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredCategoriaPregunta.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((categoriaPregunta) => (
                                            <TableRow key={categoriaPregunta.id}>
                                                <TableCell component="th" scope="row">
                                                    {categoriaPregunta.categoria}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Button onClick={() => setEditCategoriaPregunta(categoriaPregunta)} color="primary" disabled={!tienePermiso('Editar Categoría Pregunta')}>
                                                        Editar
                                                    </Button>
                                                    <Button onClick={() => handleOpenDialog(categoriaPregunta)} color="secondary" disabled={!tienePermiso('Eliminar Categoría Pregunta')}>
                                                        Eliminar
                                                    </Button>
                                                </TableCell>
                                            </TableRow>                                        
                                    ))}

                                   
                                </TableBody>
                            </Table>

                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={filteredCategoriaPregunta.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage="Filas por página:"
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                            />
                        </TableContainer>

                        <Dialog open={openDialog}
                         onClose={handleCloseDialog}
                         aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description">
                            
                            <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    ¿Estás seguro de que quieres eliminar esta categoria de pregunta?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button  onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                <Button onClick={handleDeleteCategoriaPregunta} color="primary" autoFocus>Eliminar</Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    </>

     
    );
}

export default GestionCategoriaPregunta;